import * as Sentry from '@sentry/vue'

export function shouldIgnoreError(event: Sentry.Event, hint?: Sentry.EventHint): boolean {
  const value = event?.exception?.values?.[0]?.value || ''
  const filename = event?.exception?.values?.[0]?.stacktrace?.frames?.[0]?.filename || ''

  // 自定义排除规则列表
  const ignoreMessages = [
    'ResizeObserver loop limit exceeded',
    'Script error.',
    'NetworkError',
    'Failed to fetch',
    'Load failed',
  ]

  const ignoreFilenames = ['vconsole', 'iframe', 'chrome-extension://']

  if ((hint?.originalException as any)?._noSentry) {
    return true
  }

  if (ignoreMessages.some(msg => value.includes(msg))) {
    return true
  }

  if (ignoreFilenames.some(name => filename.includes(name))) {
    return true
  }

  return false
}

// 设置标签：可以在组件中或全局拦截器中使用
export function setSentryTags({
  module,
  feature,
  userRole,
}: {
  module?: string
  feature?: string
  userRole?: string
}) {
  if (module) Sentry.setTag('module', module)
  if (feature) Sentry.setTag('feature', feature)
  if (userRole) Sentry.setTag('userRole', userRole)
}

// 设置上下文信息：用于补充结构化的调试数据
export function setSentryContext(context: Record<string, any>) {
  Object.entries(context).forEach(([key, value]) => {
    Sentry.setContext(key, value)
  })
}
